<template>
  <tr>
    <td
      v-for="(column, index) in columns"
      :key="`td-${dossier.id}-${index}`"
      :style="`width: ${cellWidth[index]}`"
    >
      <div
        class="relative min-w-[50px] overflow-x-visible"
        :style="`width: ${cellWidth[index]}`"
      >
        <DashBoardRowElement
          :column="column"
          :dossier="dossier"
          :indexcolumn="index"
          :show-tasks="showTasks"
          @toggle-tasks="handleCatchToggleTasks"
        />
      </div>
    </td>
  </tr>
  <Transition name="task-panel">
    <DossierTasksTableComponent
      v-if="showTasks && (isItemsMode || dossier.tasks?.length)"
      :dossier="dossier"
      :column-list="columns"
      :active-field="activeField"
      :column-id="columnId"
      :only-with-tasks="onlyWithTasks"
    />
  </Transition>
</template>

<script>
import DashBoardRowElement from '@c/Dashboard/Content/Dossier/components/Body/DashBoardRowElement'
import { mapGetters } from 'vuex'
import DossierTasksTableComponent from '@c/Dashboard/Content/Dossier/components/Body/TasksDossierTable/DossierTasksTableComponent'

export default {
  name: 'DossierRowComponent',
  components: { DossierTasksTableComponent, DashBoardRowElement },
  props: {
    dossier: {
      type: Object,
      required: true
    },
    indexDossier: {
      type: Number,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    cellWidth: {
      type: Object,
      required: false,
      default: () => {}
    },
    showTasks: {
      type: Boolean,
      required: false,
      default: false
    },
    activeField: {
      type: [Array, String],
      required: false,
      default: null
    },
    columnId: {
      type: [Number, String],
      required: false,
      default: null
    },
    onlyWithTasks: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  emits: ['toggle-tasks'],
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      metadata: 'metadata/getInitialMetadata',
      auth: 'auth/getAuth'
    }),
    // Mirrors DossierTasksTableComponent's own isItemsMode: item-level tasks live in
    // tasks_progress[categoryId].tasks, never in dossier.tasks, so a dossier with zero
    // dossier-level tasks but item-level ones must still be allowed to open the panel.
    isItemsMode() {
      return this.columnId != null
    }
  },
  methods: {
    handleCatchToggleTasks(payload) {
      this.$emit('toggle-tasks', {
        rowIndex: this.indexDossier,
        ...payload
      })
    },
    localCellWidth(index) {
      if (this.cellWidth[index] > 0) {
        return `${this.cellWidth[index]}px`
      }

      return 'auto'
    }
  }
}
</script>

<style scoped>
/* transform on a <tr> (display: table-row) isn't reliable across browsers, so we stick to
   an opacity fade only, no risk of broken layout. */
.task-panel-enter-active,
.task-panel-leave-active {
  transition: opacity 0.2s ease;
}
.task-panel-enter-from,
.task-panel-leave-to {
  opacity: 0;
}
</style>
